import React from 'react';
import { ShoppingMobile as ShoppingMobileType } from '../../../types/product/product';
import { shoppingMobile as shoppingMobileObject } from '../../../helpers/shoppingMobile/shoppingMobile';
import useStyle from './shoppingMobile.style';

interface ShoppingMobileProps {
  shoppingMobile: ShoppingMobileType;
}

export const ShoppingMobile = ({ shoppingMobile }: ShoppingMobileProps) => {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      {shoppingMobile.mobile && (
        <img
          className={classes.emoji}
          src={shoppingMobileObject[shoppingMobile?.mobile].emoji.url}
          alt={shoppingMobileObject[shoppingMobile?.mobile].emoji.alt}
        />
      )}
      <div>
        <h3>
          {shoppingMobile.mobile &&
            shoppingMobileObject[shoppingMobile?.mobile].name}
        </h3>
        <p>{shoppingMobile?.description}</p>
      </div>
    </div>
  );
};
